import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import API from "../api/axios";
import SearchResults from "../components/SearchResults";
import "../style/SearchResults.css";

// helper to read query params
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Search() {
  const q = useQuery();
  const initialQuery = q.get("query") || "";

  const [query, setQuery] = useState(initialQuery);
  const [results, setResults] = useState([]);
  const [allProducts, setAllProducts] = useState([]);

  // fetch all products once
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await API.get("/products");
        setAllProducts(res.data || []);
      } catch (err) {
        console.error("Failed to load products", err);
      }
    };
    fetchProducts();
  }, []);

  // filter when query changes
  // useEffect(() => {
  //   if (query.trim()) {
  //     const filtered = allProducts.filter((item) =>
  //       item.name.toLowerCase().includes(query.toLowerCase())
  //     );
  //     setResults(filtered);
  //   } else {
  //     setResults([]);
  //   }
  // }, [query, allProducts]);
  useEffect(() => {
    if (query.trim()) {
      const filtered = allProducts.filter((item) =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );
      setResults(filtered);
    } else {
      setResults(allProducts); // Show all products when query is empty!
    }
  }, [query, allProducts]);


  return (
    <div className="search-container">
      <input
        type="text"
        placeholder=" Search for products..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="search-input"
      />

      <SearchResults results={results} query={query} />
    </div>
  );
}
